import { render, staticRenderFns } from "./ExpirationDateEditor.vue?vue&type=template&id=5fbc9676&scoped=true"
import script from "./ExpirationDateEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpirationDateEditor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ExpirationDateEditor.vue?vue&type=style&index=0&id=5fbc9676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc9676",
  null
  
)

export default component.exports